export const logErrorBoundaryError = (
  error: Error,
  info: { componentStack: string }
) => {
  const renderingError = new Error(error.message);
  renderingError.name = `ReactRenderingError`;
  renderingError.stack = info.componentStack;
};
